/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  NoProductsFound.tsx
 *
 * Project Title :  Checkout
 *
 * Description	: Purchase Software page
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H175591
 *
 * @Date		    : Oct 1, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : SandeepRaja
 * On            : Oct 31, 2019
 * Description   : ASDS-1672: Empty Product Search UI & Integration
 *
 * By            : H422336
 * On            : Sep 7 2020
 * Description   : ASDS-2748 - UI Enhancements as part of Phase II
 *
 ******************************************************************************/
import React from "react";
import { Notification, Grid, Card } from "@scuf/common";
import SearchFilter from "../SearchFilter";
import { CheckoutServiceURL } from "../../constants/checkout-constants";
import { ContactUsMessage } from "../../Common/ContactUsMessage";

interface INoProductsFoundProps {
  title: string;
  message: string;
}

function NoProductsFound({ title = "" , message= ""}: INoProductsFoundProps) {
  return (
    <Grid.Row>
      <Grid.Column width={12}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={12} sWidth={7} xsWidth={12}>
              <Notification
                severity="information"
                hasIcon={true}
                title={title}
                detailsText = "BACK TO PRODUCT LISTING"
                onDetailsClick={() => window.location.reload() }
                onCloseClick={() => window.location.reload() }
              >
                  <ContactUsMessage >{message}</ContactUsMessage>
              </Notification>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={12} sWidth={7} xsWidth={12}>
              <Card className="no-results-message">
                <Card.Content>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={8} sWidth={7} xsWidth={12} className="no-results-header">
                        <h1 >
                          Search Software or Services
                        </h1>
                      </Grid.Column>
                      <SearchFilter />
                    </Grid.Row>
                  </Grid>
                  <p className="no-results-details">
                    Try checking your spellings of products you are looking for.
                    Visit <strong><a href={CheckoutServiceURL.CONTACT_US_URL} target='blank'> Contact Us</a> </strong>
                    section if you have specific questions. Honeywell support will contact you within the next 24-48 hours
                    regarding your questions.
                  </p>
                </Card.Content>
              </Card>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    </Grid.Row>
  );
}

export default NoProductsFound;
